import React from 'react';

const TestimonialSection = ({ 
  imageSrc = "/DSC00065.jpg",  // Default image path that can be overridden
  imageAlt = "Client in outdoor setting"  // Default alt text that can be overridden
}) => {
  return (
    <div className="flex flex-col md:flex-row bg-white overflow-hidden">
      {/* Left side - Image */}
      <div className="md:w-1/2">
        <img 
          src={imageSrc} 
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Right side - Testimonial */}
      <div className="md:w-1/2 bg-[#336fb8] p-8 flex flex-col justify-center">
        <h2 className="text-white text-4xl font-bold mb-8">
          Testimonials
        </h2>
        
        <blockquote className="text-white text-lg mb-6">
          "I wish to thank Livability Care for the efficient and smooth transition for my participant into his new home. Right from the first contact I have been impressed with the service provided, care and dedication shown to my participant, guardian, and myself as the Support Coordinator. I highly recommend Livability Care as their dedication and care to participants and families is of the highest quality I have seen for some time in this industry. Well done to all the staff working with my participant who has settled in well in his new home and has his old sparkle back."
        </blockquote>
        
        <p className="text-white text-lg">
          Naomi Toth, Team Leader, Support Coordinator, ACCESS 4U
        </p>
      </div>
    </div>
  );
};

export default TestimonialSection;